import {Box} from "@dladio/core-ui";
import React from "react";
import {Spinner} from "@fluentui/react";

const Loading = () => {
    return (
        <Box>
            <div className={'h-[85vh] flex flex-col justify-center'}>
                <Spinner label="Loading..."/>
            </div>
        </Box>
    )
}

export default Loading